import type { ModuleDefinition } from "../types";
import "./messages.nav";
import { COMMS_MESSAGES, COMMS_READ, COMMS_SETTINGS } from "./permissions";
import { TextsBadge } from "./TextsBadge";

const screens = () => import("./screens");

export const communicationsModule: ModuleDefinition = {
  id: "communications",
  labelKey: "comms.module",
  nav: [
    { id: "messages", labelKey: "comms.nav.messages", to: "/communications/messages", icon: "log", permission: COMMS_MESSAGES },
    { id: "texts", labelKey: "comms.nav.texts", to: "/communications/texts", icon: "message", permission: COMMS_READ, badge: TextsBadge },
    { id: "log", labelKey: "comms.nav.log", to: "/communications/log", icon: "clock", permission: COMMS_READ },
    { id: "settings", labelKey: "comms.nav.settings", to: "/communications/settings", icon: "globe", permission: COMMS_SETTINGS },
  ],
  routes: [
    // The messages page decides for itself between "For me" (comms.messages) and "All" (comms.read), so the route asks for neither alone.
    { path: "communications/messages", load: async () => ({ default: (await screens()).PhoneMessagesPage }) },
    { path: "communications/texts", permission: COMMS_READ, load: async () => ({ default: (await screens()).TextsPage }) },
    { path: "communications/log", permission: COMMS_READ, load: async () => ({ default: (await screens()).CallLogPage }) },
    { path: "communications/settings", permission: COMMS_SETTINGS, load: async () => ({ default: (await screens()).SettingsPage }) },
  ],
};
